import { Component, Input } from '@angular/core';
import { TimelineNode, TimelineNodeState } from './timeline.model';
import { CommonModule } from '@angular/common';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-timeline',
  imports: [CommonModule, AngularSvgIconModule],
  templateUrl: './timeline.component.html',
})
export class TimelineComponent {
  @Input() timeline: TimelineNode[] = [];

  TimelineNodeState = TimelineNodeState;
}
